import React from "react";
import PropTypes from "prop-types";
import { NeoFinancialTable, NeoButton, NeoBadge, AvatarPreview } from "../../../../components/Common";
import { formatDate } from "../../../../utils/date";


/**
 * CancellationsTable
 * Tabela de cancelamentos usando NeoFinancialTable.
 */
const CancellationsTable = ({
    records,
    loading,
    hasMore,
    onLoadMore,
    search,
    onSearchChange,
}) => {

    const columns = [
        {
            key: 'updatedAt',
            label: 'Data Cancel.',
            width: '130px',
            render: (r) => (
                <div className="d-flex align-items-center gap-1 font-size-12 fw-bold text-danger">
                    <i className="mdi mdi-calendar-remove me-1"></i>
                    {r.updatedAt ? formatDate(r.updatedAt) : "—"}
                </div>
            )
        },
        {
            key: 'memberName',
            label: 'Aluno',
            render: (r) => (
                <div className="d-flex align-items-center gap-2">
                    <AvatarPreview
                        name={r.memberName}
                        size="xs"
                        className="flex-shrink-0"
                    />
                    <span className="fw-semibold text-dark font-size-13 neo-font-outfit">
                        {r.memberName || "—"}
                    </span>
                </div>
            )
        },
        {
            key: 'membershipName',
            label: 'Plano Original',
            width: '160px',
            render: (r) => (
                <NeoBadge color="primary" solid={false}>
                    {r.membershipName || "—"}
                </NeoBadge>
            )
        },
        {
            key: 'endDate',
            label: 'Fim Previsto',
            width: '120px',
            render: (r) => (
                <div className="font-size-12 text-muted">
                    <i className="mdi mdi-calendar-clock me-1"></i>
                    {r.endDate ? formatDate(r.endDate) : "—"}
                </div>
            )
        },
        {
            key: 'cancelReason',
            label: 'Motivo',
            render: (r) => (
                <div className="d-flex flex-column gap-1">
                    <span className="text-muted font-size-12">
                        {r.cancelReason || "Não informado"}
                    </span>
                    {r.isTransfer && (
                        <NeoBadge color="info" icon="mdi-swap-horizontal">
                            Transferência
                        </NeoBadge>
                    )}
                </div>
            )
        }
    ];

    // ── Detalhes expandidos ──
    const renderRowDetails = (r) => (
        <>
            <div className="text-muted font-size-11 fw-bold text-uppercase d-flex align-items-center gap-3 flex-wrap">
                <span><i className="mdi mdi-calendar-remove me-1 text-danger"></i>Cancelado em: {r.updatedAt ? formatDate(r.updatedAt) : "—"}</span>
                {r.endDate && (
                    <>
                        <span>|</span>
                        <span><i className="mdi mdi-calendar-clock me-1"></i>Fim previsto: {formatDate(r.endDate)}</span>
                    </>
                )}
                {r.isTransfer && (
                    <>
                        <span>|</span>
                        <span><i className="mdi mdi-swap-horizontal me-1 text-info"></i>Transferência</span>
                    </>
                )}
            </div>
            <div className="mt-2 d-flex justify-content-between align-items-start border-top pt-2">
                <div>
                    <span className="fw-semibold font-size-13 text-dark neo-font-outfit d-block">
                        {r.memberName?.toUpperCase()}
                    </span>
                    <small className="text-muted font-size-11">
                        Plano: {r.membershipName || "—"}
                    </small>
                </div>
                <div className="text-end">
                    <small className="text-muted font-size-11 d-block fw-bold text-uppercase">Motivo</small>
                    <span className="font-size-12 text-muted">{r.cancelReason || "Não informado"}</span>
                </div>
            </div>
        </>
    );

    return (
        <>
            <NeoFinancialTable
                columns={columns}
                data={records}
                keyField="id"
                loading={loading}
                renderRowDetails={renderRowDetails}
                searchValue={search}
                onSearchChange={onSearchChange}
                searchPlaceholder="Buscar por aluno, plano..."
                defaultItemsPerPage={20}
                itemsPerPageOptions={[10, 20, 50, 100]}
                emptyMessage="Nenhum cancelamento encontrado"
                emptySubMessage="Selecione o período acima e clique em 'Buscar' para carregar os cancelamentos."
            />

            {hasMore && (
                <div className="text-center py-3 border-top">
                    <NeoButton
                        variant="outline-secondary"
                        size="sm"
                        onClick={onLoadMore}
                        loading={loading}
                        loadingText="Carregando..."
                        className="px-4"
                        icon="mdi-chevron-down"
                    >
                        Carregar mais cancelamentos
                    </NeoButton>
                </div>
            )}
        </>
    );
};

CancellationsTable.propTypes = {
    records: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    hasMore: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    search: PropTypes.string.isRequired,
    onSearchChange: PropTypes.func.isRequired,
};

export default CancellationsTable;
